import React, { useContext, useState } from 'react';
import { useDisclosure, Grid, GridItem } from '@chakra-ui/react';
import BannerForm from './BannerForm';
import Banner from './Banner';
import context from '../context';

const Banners: React.FC = () => {
  const { pageGroup } = useContext(context);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [clickedBanner, setClickedBanner] = useState<any | undefined>(
    undefined,
  );

  const segunda = pageGroup?.type === 'second_line';
  return (
    <>
      <Grid
        templateRows="repeat(2, 100px)"
        templateColumns="repeat(2, 1fr)"
        gap={3}
        justifyContent="center"
        mt={2}
      >
        <GridItem colStart={1} rowStart={1} rowSpan={segunda ? 2 : 1}>
          <Banner
            banner={pageGroup?.items[0]}
            index={0}
            disabled={false}
            onClick={banner => {
              onOpen();
              setClickedBanner(banner);
            }}
          />
        </GridItem>
        <GridItem colStart={segunda ? 2 : 1} rowStart={segunda ? 1 : 2}>
          <Banner
            banner={pageGroup?.items[1]}
            index={0}
            disabled={false}
            onClick={banner => {
              onOpen();
              setClickedBanner(banner);
            }}
          />
        </GridItem>
        <GridItem
          colStart={2}
          rowStart={segunda ? 2 : 1}
          rowSpan={segunda ? 1 : 2}
        >
          <Banner
            banner={pageGroup?.items[2]}
            index={0}
            disabled={false}
            onClick={banner => {
              onOpen();
              setClickedBanner(banner);
            }}
          />
        </GridItem>
      </Grid>

      <BannerForm
        isOpen={isOpen}
        banner={clickedBanner}
        onCreated={onClose}
        onClose={() => {
          setClickedBanner(undefined);
          onClose();
        }}
        onDeleted={() => {
          setClickedBanner(undefined);
          onClose();
        }}
        onUpdated={() => {
          setClickedBanner(undefined);
          onClose();
        }}
      />
    </>
  );
};

export default Banners;
